import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';

interface FilterBarProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  filters?: Array<{
    label: string;
    value: string;
    options: Array<{ label: string; value: string }>;
    onChange: (value: string) => void;
  }>;
  onClear?: () => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  searchValue,
  onSearchChange,
  filters = [],
  onClear,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" sx={{ flexWrap: 'wrap' }}>
        {onSearchChange && (
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 300px' }, minWidth: 200 }}>
            <TextField
              fullWidth
              placeholder="Search..."
              value={searchValue || ''}
              onChange={(e) => onSearchChange(e.target.value)}
              InputProps={{
                startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />,
              }}
            />
          </Box>
        )}
        {filters.map((filter, index) => (
          <Box key={index} sx={{ flex: { xs: '1 1 100%', sm: '1 1 200px' }, minWidth: 200 }}>
            <FormControl fullWidth>
              <InputLabel>{filter.label}</InputLabel>
              <Select
                value={filter.value}
                label={filter.label}
                onChange={(e) => filter.onChange(e.target.value)}
              >
                {filter.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ))}
        {onClear && (
          <Box>
            <Button
              startIcon={<Clear />}
              onClick={onClear}
              variant="outlined"
            >
              Clear Filters
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

